<template>
  <div class="row justify-content-center">
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Time Picker</h4>
          <ul class="nav nav-tabs mb-4" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code-tab"
                data-bs-toggle="tab"
                data-bs-target="#code-tab-pane"
                type="button"
                role="tab"
                aria-controls="code-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active"
              id="preview-tab-pane"
              role="tabpanel"
              aria-labelledby="preview-tab"
              tabindex="0"
            >
              <div class="form-group mb-0">
                <label class="label">Time Picker</label>
                <div class="form-group position-relative">
                  <input
                    type="time"
                    class="form-control h-55 text-dark ps-5 h-58"
                  />
                  <i
                    class="ri-time-line position-absolute top-50 translate-middle-y fs-20 text-gray-light ps-20"
                  ></i>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code-tab-pane"
              role="tabpanel"
              aria-labelledby="code-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode">
<div>&lt;div class="form-group mb-0"&gt;</div>
<div>     &lt;label class="label"&gt;Time Picker&lt;/label&gt;</div>
<div>     &lt;div class="form-group position-relative"&gt;</div>
<div>         &lt;input type="time" class="form-control h-55 text-dark ps-5 h-58" style="left: 15px;"&gt;</div>
<div>         &lt;i class="ri-time-line position-absolute top-50 translate-middle-y fs-20 text-gray-light ps-20"&gt;&lt;/i&gt;</div>
<div>   &lt;/div&gt;</div>
<div>&lt;/div&gt;</div>
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h4 class="fs-18 mb-4">Date Picker</h4>
          <ul class="nav nav-tabs mb-4" id="myTab2" role="tablist">
            <li class="nav-item" role="presentation">
              <button
                class="nav-link active"
                id="preview2-tab"
                data-bs-toggle="tab"
                data-bs-target="#preview2-tab-pane"
                type="button"
                role="tab"
                aria-controls="preview2-tab-pane"
                aria-selected="true"
              >
                Preview
              </button>
            </li>
            <li class="nav-item" role="presentation">
              <button
                class="nav-link"
                id="code2-tab"
                data-bs-toggle="tab"
                data-bs-target="#code2-tab-pane"
                type="button"
                role="tab"
                aria-controls="code2-tab-pane"
                aria-selected="false"
              >
                Code
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent2">
            <div
              class="tab-pane fade show active"
              id="preview2-tab-pane"
              role="tabpanel"
              aria-labelledby="preview2-tab"
              tabindex="0"
            >
              <div class="form-group mb-0">
                <label class="label">Date Picker</label>
                <div class="form-group position-relative">
                  <input
                    type="date"
                    class="form-control h-55 text-dark ps-5 h-58"
                  />
                  <i
                    class="ri-calendar-line position-absolute top-50 translate-middle-y fs-20 text-gray-light ps-20"
                  ></i>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="code2-tab-pane"
              role="tabpanel"
              aria-labelledby="code2-tab"
              tabindex="0"
            >
              <button
                class="btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0"
                data-clipboard-target="#basicAlertsCode2"
              >
                Copy
              </button>
              <pre class="line-numbers pt-0 pb-0 ps-25 pe-25 mb-0">
<code class="language-markup" id="basicAlertsCode2">
<div>&lt;div class="form-group mb-0"&gt;</div>
<div>   &lt;label class="label"&gt;Date Picker&lt;/label&gt;</div>
<div>     &lt;div class="form-group position-relative"&gt;</div>
<div>         &lt;input type="date" class="form-control h-55 text-dark ps-5 h-58"&gt;</div>
<div>         &lt;i class="ri-calendar-line position-absolute top-50 translate-middle-y fs-20 text-gray-light ps-20"&gt;&lt;/i&gt;</div>
<div>     &lt;/div&gt;</div>
<div>&lt;/div&gt;</div>
</code>
</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import Prism from "prismjs";
import "prismjs/themes/prism.min.css";

export default defineComponent({
  name: "DateTimePicker",
  setup() {
    onMounted(() => {
      Prism.highlightAll();
    });
  },
});
</script>
